<template>
  <div class="c-tab-placement">
    <div class="o-grid o-grid--gutter-large">
      <div class="o-grid__group">
        <div class="o-grid__item  o-grid__item--4">
          <div class="o-grid o-grid--gutter-large">
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <CallCenterAEDaddress></CallCenterAEDaddress>
              </div>
              <div class="o-grid__item o-grid__item--12">
                <CallCenterAEDplacement></CallCenterAEDplacement>
              </div>
            </div>
          </div>
        </div>
        <div class="o-grid__item  o-grid__item--8">
          <CallCenterAEDmap></CallCenterAEDmap>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallCenterAEDaddress from "@/components/AED/aed-address.vue";
import CallCenterAEDplacement from "@/components/AED/aed-placement.vue";
import CallCenterAEDmap from "@/components/AED/aed-map.vue";
export default {
  name: "c-tab-placement",
  components: {
    CallCenterAEDaddress,
    CallCenterAEDplacement,
    CallCenterAEDmap
  }
};
</script>
<style lang="scss">
.c-tab-placement {
}
</style>
